module.exports = __webpack_public_path__ + "img/blog-10.15966efa.jpg";